<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="3" viewBox="0 0 13 3" fill="none">
    <path d="M1.94629 1.78516H11.9463" stroke="#606060" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>
